import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Pagination, STableLoader, FilterComponent, PageLoader, EmptyCollection, STabsLoader, DeletePopUp } from '../../shared_elements';
import { SettingsNavWrapper } from '../../elements'
import { ActiveList, ActiveUserHeader, AddUser } from '../components'
import { Table, TableBody, Paper, Grid, Button, TextField } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { SaveAlt } from '@material-ui/icons';
import { globalGetService, globalExportService, globalPostService } from '../../../globalServices';
import { checkApiStatus, checkPermission } from '../../utils_v2';
import { downloadFileType } from '../../../utils'
import { userFilters } from '../'
import DeploymentMessage from '../../../shared/components/DeploymentMessage';
import { trackActivity } from '../../../utils/mixpanel';
import { usePageTitleOffset } from '../../elements/CollapsibleSideNav';
const ActiveUsers = ({}) => {
    const navTitleOffset = usePageTitleOffset('settingsNavCollapsed');
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo,setSortInfo] = useState({sort:'', sort_by:''});
    const [filter, setFilter] = useState({});
    const [addUser, setAddUser] = useState({modal:false})
    const [userInfo, setUserInfo] = useState({list:[], pagination:{}})
    const [isBannerActive, setIsBannerActive] = useState(false);
    const [pageSelections, setPageSelections] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [bulkDeactivate, setBulkDeactivate] = useState({modal:false})
    const [deactivateUser, setDeactivateUser] = useState({modal:false, user:null})
    
    useEffect(() => {
        getActiveUsers({page:1, per_page:50},'skeletonLoader');
        trackActivity('Console Management', { page_title: 'Active Users', event_type: 'Page Visit', event_desc: 'Active Users Page Visited' })
    },[]);

    const getActiveUsers = (query, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true):setLoading(true);
        globalGetService(`v2/get-user-list/?exclude_fields=group_profile_order,profile_pic&exclude_count=1`, query)
        .then(response => {
            if(checkApiStatus(response)){
                setUserInfo(response.data.data)
                delete query.page
                delete query.per_page
                delete query.sort
                delete query.sort_by
                setFilter(query)
            }
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false):setLoading(false);
        });
    }
    const createSortHandler = (key) => {
        let sortQuery = {sort:key};
        if(sortInfo.sort === key){
            sortQuery = { ...sortQuery, sort_by:sortInfo.sort_by === 'asc'?'desc':'asc'}
        }else{
            sortQuery = { ...sortQuery, sort_by:'asc'}
        }
        setSortInfo(sortQuery)
        getActiveUsers({...filter, ...sortQuery, page:1, per_page:userInfo.pagination.per_page},'pageLoader');
    }
   
    const onBulkDeactivate = () => {
        const ids = Object.values(pageSelections).flat();
        setLoading(true);
        Promise.all(ids.map(id => {
            const user = userInfo.list.find(item => item.id === id);
            return globalPostService(`console/user-activate-deactivate/`, {
                user: { id: user.id, name: `${user.first_name} ${user.last_name}`, email: user.email },
                is_active: false
            });
        })).then(() => {
            setLoading(false);
            setBulkDeactivate({modal:false});
            setPageSelections({});
            getActiveUsers({...filter, sort:sortInfo.sort, sort_by:sortInfo.sort_by, page:userInfo.pagination.page, per_page:userInfo.pagination.per_page}, 'pageLoader');
            enqueueSnackbar('Selected user(s) deactivated successfully', { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            trackActivity('Console Management', { page_title: 'Active Users', item_type: 'Bulk Deactivate', event_type: 'Item Deactivated', event_desc: 'Deactivated selected users successfully', deactivated_ids: ids });
        });
    }
    const onDeactivateUser = () => {
        const user = deactivateUser.user;
        setLoading(true);
        globalPostService(`console/user-activate-deactivate/`, {
            user: { id: user.id, name: `${user.first_name} ${user.last_name}`, email: user.email },
            is_active: false
        }).then(response => {
            if(checkApiStatus(response)){
                setDeactivateUser({modal:false, user:null});
                getActiveUsers({...filter, sort:sortInfo.sort, sort_by:sortInfo.sort_by, page:userInfo.pagination.page, per_page:userInfo.pagination.per_page}, 'pageLoader');
                enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                trackActivity('Console Management', { page_title: 'Active Users', item_type: 'Deactivate', event_type: 'Item Deactivated', event_desc: 'Deactivated user successfully', deactivated_id: user.id });
            }else{
                enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            }
            setLoading(false);
        });
    }
    const onExportUsers = () => {
        globalExportService(`v2/get-user-list/`, {...filter, download:'xls'})
        .then(response => {
            downloadFileType(response, 'Users List.', 'xls')
            trackActivity('Console Management', { page_title: 'Active Users', item_type: 'Export',  event_type:'item Exported', event_desc: 'Exported Active Users Successfully' })
        });
    }
    const selectedCount = (pageSelections[currentPage]||[]).length;
    return(
        <section className='roles-management asset-tech-specs' style={{margin:'25px 0 0 75px'}}>
             <DeploymentMessage  onStatusChange={setIsBannerActive}/>
            <Paper elevation={0} className='tech-specs-card console-paper' style={{height: `${window.innerHeight - (isBannerActive ? 129 : 89)}px`}}>
            <SettingsNavWrapper />
            <div className='tech-specs-content' style={{padding: '10px'}}>
            <div>
                { skeletonLoader ? <><STabsLoader count={5} fullWidth/> 
                <STableLoader count={5} size={8}/></>:
                    <>
                        <Paper elevation={0} className='console-paper' style={{padding:'5px 10px', marginBottom: "2px"}}>
                            <Grid container spacing={1} alignItems='center'>
                                <Grid item md={7}>
                                    <FilterComponent
                                        filter={filter}
                                        filterMenu={userFilters}
                                        getResponseBack={(applyFilter) => getActiveUsers({...applyFilter, page:1, per_page:userInfo.pagination.per_page}, 'pageLoader')}
                                    />
                                </Grid>
                                <Grid item md={5}>
                                    <ul className='list-inline' style={{float:'right', display:'flex', flexWrap:'nowrap', alignItems:'center', whiteSpace:'nowrap'}}>
                                        { selectedCount > 0 && checkPermission('settings', 'manage_user','U') ?
                                            <li className='list-inline-item'>
                                                <Button onClick={() => setBulkDeactivate({modal:true})} color='secondary' variant='contained' size='small'>Deactivate ({selectedCount})</Button>
                                            </li>:null
                                        }
                                        { checkPermission('settings', 'manage_user','EXP') ?
                                            <li className='list-inline-item'>
                                                <Button startIcon={<SaveAlt style={{ fontSize: '1.2rem' }} />} onClick={onExportUsers} color='primary' variant='outlined' size='small'>Export</Button>
                                            </li>:null
                                        }
                                        {checkPermission('settings', 'manage_user','C') ?
                                            <li className='list-inline-item'>
                                                <Button onClick={() => setAddUser({modal:true})} color='primary' variant='contained' size='small'><AddIcon style={{ fontSize: '1.15rem' }} />Add User</Button>
                                            </li>:null
                                        }
                                    </ul>
                                </Grid>
                            </Grid>
                        </Paper>
                        <Paper square>
                            <div style={{ height: `${(window.innerHeight - (userInfo.list.length ? 200 : 150) - (isBannerActive ? 40 : 0)) - navTitleOffset}px`, overflow: 'auto' }}>
                                <Table className='mui-table-format hovered-table' stickyHeader>
                                    <ActiveUserHeader
                                        createSortHandler={createSortHandler}
                                        sortInfo={sortInfo}
                                    />
                                    <TableBody>
                                        {userInfo.list.length > 0 && userInfo.list.map((item, index) =>
                                            <ActiveList
                                                item={item}
                                                key={index}
                                                onDeactivate={(user) => setDeactivateUser({ modal: true, user })}
                                            />
                                        )}
                                    </TableBody>
                                </Table>
                                {!userInfo.list.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title={'No records found'} /></div> : null}
                            </div>
                        </Paper>
                        <Paper square>
                            <Pagination
                                pagination={userInfo.pagination}
                                onChangePage={(event, newPage) => { getActiveUsers({ ...filter, sort: sortInfo.sort, sort_by: sortInfo.sort_by, page: newPage + 1, per_page: userInfo.pagination.per_page }, 'pageLoader'); setCurrentPage(newPage + 1) }}
                                onChangeRowsPerPage={(event) => getActiveUsers({ ...filter, sort: sortInfo.sort, sort_by: sortInfo.sort_by, page: 1, per_page: event.target.value }, 'pageLoader')}
                            />
                        </Paper>
                    </>
                    
                }
            </div>
            {addUser.modal?
                <AddUser 
                    getResponseBack={()=>getActiveUsers({page:1, per_page:50})}
                    addUser={addUser}
                    toggleModalFn={()=> setAddUser({modal:false})}
                />:null
            }
            <DeletePopUp
                modal={bulkDeactivate.modal}
                title={`Deactivate Users (${selectedCount})`}
                content='Are you sure, you want to deactivate the selected user(s)? They will lose access immediately.'
                toggleModalFn={() => setBulkDeactivate({modal:false})}
                deleteRecordFn={onBulkDeactivate}
                confirmText='Deactivate'
                confirmColor='secondary'
            />
            <DeletePopUp
                modal={deactivateUser.modal}
                title='Deactivate User'
                content={`Are you sure, you want to deactivate ${deactivateUser.user?.first_name||''} ${deactivateUser.user?.last_name||''}? They will lose access immediately.`}
                toggleModalFn={() => setDeactivateUser({modal:false, user:null})}
                deleteRecordFn={onDeactivateUser}
                confirmText='Deactivate'
                confirmColor='secondary'
            />
            {isLoading ? <PageLoader/>:null}
            </div>
            </Paper>
        </section>
    )
}
export default ActiveUsers;